import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  inject,
  TemplateRef,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {Handler} from "src/app/common/handler";
import {HandleCommand} from "../handle-command";
import {defaultModalOptions, ModalOptions, OpenModal} from './modal';
import {View} from '../view';
import Modal from 'bootstrap/js/dist/modal';
import {HandleEvent} from '../handle-event';
import {publishEvent} from "../app-common-utils";
import {cloneDeep} from "lodash";

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
@Handler()
export class ModalComponent extends View implements AfterViewInit {
  changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);

  @ViewChild('modal', {static: true}) modal: ElementRef;
  @ViewChild('container', {read: ViewContainerRef}) container: ViewContainerRef;
  options: ModalOptions;
  closeArgs: any;

  ngAfterViewInit(): void {
    $(this.modal.nativeElement).on('shown.bs.modal', (event) => {
      if (event.target !== this.modal.nativeElement) return;
      publishEvent("modalOpened", this, this.modal);
    });
    $(this.modal.nativeElement).on('hidden.bs.modal', (event) => {
      if (event.target !== this.modal.nativeElement) return;
      publishEvent("modalClosed", this, this.modal);
      this.container.clear();
      if (this.options.closeCallback) {
        this.options.closeCallback(this.closeArgs);
        this.closeArgs = null;
      }
    });
  }

  openModal(command: OpenModal) {
    this.container.clear();
    this.options = command.options || defaultModalOptions;
    setTimeout(() => {
      if (command.component instanceof TemplateRef) {
        this.container.createEmbeddedView(command.component);
      } else {
        const componentRef = this.container.createComponent(<any>command.component);
        const component = componentRef.instance;
        component['data'] = command.data;
        $(componentRef.location.nativeElement).addClass('modal-content');
      }
      const options = cloneDeep(this.options);
      options.backdrop = false;
      Modal.getOrCreateInstance(this.modal.nativeElement, options).show();
      this.changeDetectorRef.detectChanges();
    }, 0);
  }

  closeModalOnClick = (event: MouseEvent, intendedTarget: Element) => {
    const containsStaticContent = intendedTarget.querySelector('[data-modal-backdrop-static]');
    if (!containsStaticContent && this.options?.backdrop !== 'static' && event.target === intendedTarget) {
      this.closeModal();
    }
  }

  @HandleCommand("closeModal")
  closeModal(closeArgs?: any) {
    if (closeArgs) {
      this.closeArgs = closeArgs;
    }
    $(this.modal.nativeElement).modal('hide');
  }

  @HandleEvent("commandSuccess")
  onSuccess(returnValue : any) {
    if (this.options.closeOnSuccess) {
      this.closeModal(returnValue);
    }
  }
}
